<script lang="ts">
  import { receive } from '~/animations/crossfade.svelte';
  import type { Tile } from '~/types';
  import { getDimensions } from '~/utils/DimensionsContext.svelte';

  type Props = {
    word: Tile[];
  };
  const props: Props = $props();
  const dims = getDimensions();
</script>

<div class="shadows">
  {#each props.word as tile, i (tile.id)}
    <div
      class="shadow-container"
      style="
        --tile-width: {dims.board.width / 12}px;
      "
      in:receive|global={{
        key: `${tile.id}-shadow`,
        index: i,
      }}
    ></div>
  {/each}
</div>

<style lang="scss">
  .shadows {
    position: absolute;
    pointer-events: none;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: grid;
    grid-auto-flow: column;
    align-items: center;
    justify-content: center;
    column-gap: 0.25em;
    .shadow-container {
      width: var(--tile-width);
      height: var(--tile-width);
    }
  }
</style>
